var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_80)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_80)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5649 31.3111C47.6437 33.6821 46.9051 35.6372 46.9236 35.6558C46.9422 35.6745 47.3327 35.616 47.7915 35.5257C48.9366 35.3006 51.5934 35.2981 52.7834 35.5211C53.2453 35.6077 53.6366 35.6649 53.6531 35.6484C53.6937 35.6075 50.3411 26.9995 50.2847 27C50.26 27.0002 49.4861 28.9402 48.5649 31.3111ZM40.3312 29.2843C40.3312 29.7802 40.8057 35.3673 40.851 35.405C40.9976 35.5267 43.6863 36.2995 43.7421 36.2359C43.8484 36.1148 44.8305 33.5031 44.7995 33.4242C44.7833 33.3827 43.8594 32.4989 42.7466 31.4602C40.4109 29.2801 40.3312 29.2083 40.3312 29.2843ZM57.9515 31.298C56.7679 32.4152 55.7861 33.3675 55.7698 33.4143C55.7388 33.5037 56.7185 36.1123 56.8308 36.2396C56.8907 36.3073 59.5817 35.5311 59.7141 35.4079C59.7464 35.3778 59.8576 34.1336 59.9613 32.643C60.0649 31.1525 60.1701 29.7805 60.195 29.5942C60.2198 29.4079 60.2095 29.258 60.1719 29.2611C60.1344 29.2643 59.1352 30.1809 57.9515 31.298ZM32.4722 35.8038C32.509 35.9004 35.6928 41.493 36.9906 43.7406C37.0149 43.7827 37.2102 43.4864 37.4247 43.0822C38.2292 41.5652 39.3712 40.1062 40.5756 39.0566C40.9746 38.709 41.2926 38.4158 41.2825 38.405C41.2569 38.3781 32.5315 35.6693 32.4703 35.6693C32.4432 35.6693 32.444 35.7298 32.4722 35.8038ZM63.6244 37.0445L59.254 38.4092L59.634 38.724C60.9063 39.778 62.2933 41.4954 63.1196 43.0397C63.3481 43.4669 63.5549 43.7821 63.579 43.7402C64.9119 41.4307 68.0603 35.9005 68.0971 35.8038C68.1253 35.7298 68.1137 35.6716 68.0715 35.6745C68.0293 35.6774 66.028 36.294 63.6244 37.0445ZM30.9106 44.4279C29.4034 44.6639 28.1229 44.8731 28.0649 44.8929C28.0069 44.9126 29.0954 45.7087 30.4839 46.6619L33.0082 48.3951L34.2879 47.5218L35.5677 46.6486L35.4045 46.3758C35.3147 46.2259 34.9709 45.6255 34.6402 45.0417C34.1533 44.1817 34.0024 43.982 33.845 43.9895C33.7382 43.9946 32.4177 44.1919 30.9106 44.4279ZM65.9291 45.0417C65.5985 45.6255 65.2553 46.2251 65.1665 46.3741L65.0049 46.6451L66.2757 47.5153L67.5463 48.3855L70.092 46.6365C71.4921 45.6745 72.5816 44.8697 72.5131 44.848C72.3468 44.7951 66.8669 43.9802 66.678 43.9802C66.583 43.9802 66.3149 44.3602 65.9291 45.0417ZM31.797 52.5059C29.6926 53.9523 27.9839 55.1492 28.0001 55.1654C28.0402 55.2058 36.7397 56.5324 36.9808 56.5349C37.1649 56.5368 37.1589 56.5052 36.8275 55.7308C36.2031 54.2718 35.8175 52.61 35.6915 50.8352L35.6235 49.8761L31.797 52.5059ZM64.8675 50.8561C64.7624 52.5984 64.3155 54.4757 63.6584 55.9358C63.4029 56.5035 63.3978 56.5369 63.5654 56.5369C63.8165 56.5369 72.0666 55.2892 72.3681 55.2056C72.6385 55.1307 73.1247 55.4849 66.731 51.0991L64.9274 49.8619L64.8675 50.8561ZM33.9257 61.6943C33.1012 63.1397 32.4462 64.342 32.4701 64.3661C32.5188 64.4151 38.1006 62.6956 38.193 62.6031C38.2687 62.5272 38.4877 59.6181 38.4226 59.5525C38.3793 59.509 35.7822 59.0756 35.5242 59.0689C35.4696 59.0675 34.7504 60.2489 33.9257 61.6943ZM63.5243 59.2948C62.7918 59.4112 62.1711 59.528 62.145 59.5543C62.094 59.6055 62.296 62.519 62.3547 62.5818C62.4067 62.6372 68.1474 64.4083 68.1752 64.3774C68.1882 64.3629 67.5215 63.1721 66.6937 61.7312C65.6255 59.8719 65.1402 59.1073 65.0223 59.0973C64.931 59.0895 64.2568 59.1783 63.5243 59.2948ZM41.0116 61.7087C40.9532 62.0031 40.327 70.7455 40.3619 70.7807C40.3933 70.8124 47.0844 64.5846 47.1265 64.4844C47.1404 64.4514 46.8782 64.3511 46.5437 64.2614C44.9631 63.8373 43.1844 62.9932 41.8723 62.0444C41.4622 61.748 41.1099 61.5054 41.0894 61.5054C41.0688 61.5054 41.0339 61.5968 41.0116 61.7087ZM59.2952 61.5979C59.1827 61.7815 57.657 62.7585 56.8283 63.1778C55.9189 63.638 54.6556 64.1222 53.8939 64.3027C53.635 64.364 53.4263 64.4406 53.4301 64.4729C53.4394 64.5505 60.1737 70.8146 60.2093 70.7789C60.243 70.745 59.6142 61.9932 59.5577 61.7087C59.5152 61.4947 59.3908 61.4422 59.2952 61.5979ZM49.2516 66.2118C48.7101 66.7136 48.2144 67.1745 48.1501 67.2361C48.0547 67.3277 48.2335 67.8626 49.1208 70.1406C49.719 71.6763 50.237 72.9627 50.2719 72.9992C50.3069 73.0356 50.8343 71.7824 51.4438 70.2142C52.5279 67.4254 52.5484 67.3594 52.3823 67.1981C51.7626 66.5965 50.3326 65.2995 50.289 65.2995C50.2599 65.2995 49.7931 65.71 49.2516 66.2118Z",
    fill: "#393184"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1062_80)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1378 33.1144C41.477 33.9548 36.0507 38.3477 33.948 44.6014C33.2727 46.6102 33.1221 47.6032 33.1221 50.0483C33.1221 52.4933 33.2727 53.4864 33.948 55.4952C36.8015 63.9823 45.733 68.7903 54.3749 66.491C60.5412 64.8504 65.249 59.7567 66.615 53.2476C66.9674 51.5686 66.9358 48.3511 66.5497 46.6034C64.9741 39.4699 59.5108 34.2995 52.4019 33.2141C51.3008 33.046 49.0902 32.9943 48.1378 33.1144Z",
    fill: "url(#paint1_linear_1062_80)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1378 33.1144C41.477 33.9548 36.0507 38.3477 33.948 44.6014C33.2727 46.6102 33.1221 47.6032 33.1221 50.0483C33.1221 52.4933 33.2727 53.4864 33.948 55.4952C36.8015 63.9823 45.733 68.7903 54.3749 66.491C60.5412 64.8504 65.249 59.7567 66.615 53.2476C66.9674 51.5686 66.9358 48.3511 66.5497 46.6034C64.9741 39.4699 59.5108 34.2995 52.4019 33.2141C51.3008 33.046 49.0902 32.9943 48.1378 33.1144Z",
    stroke: "url(#paint2_linear_1062_80)",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_80",
    x: 26.1,
    y: 25.1,
    width: 48.3166,
    height: 49.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_80",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1062_80",
    x: 30.9721,
    y: 30.8988,
    width: 38.0383,
    height: 38.3156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_80",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_80",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_80",
    x1: 36.7325,
    y1: 36.1872,
    x2: 73.2739,
    y2: 54.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_80",
    x1: 52.8028,
    y1: 38.7181,
    x2: 65.6305,
    y2: 68.4056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.b579cf6afdb0fc2ae1dc6a5799306948.svg";
export { ForwardRef as ReactComponent };